export default __webpack_public_path__ + "static/media/alternatives.257445ee.svg";